import { h } from 'preact';

export default (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -400 2400 3200" role="img" {...props}>
			<path d="M500 0 0 500v1800h600v500l500-500h400l900-900V0H500zm1700 1300-400 400h-400l-350 350v-350H600V200h1600v1100z" />
			<path d="M1700 550h200v600h-200zm-550 0h200v600h-200z" />
		</svg>
	);
};
